var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.88833 30.3571H23.1112C25.8838 30.3571 27.2632 28.9645 27.2632 26.1651V5.84797C27.2632 3.06225 25.8838 1.64282 23.1112 1.64282H8.88833C6.12947 1.64282 4.73633 3.06225 4.73633 5.84854V26.1651C4.73633 28.964 6.12947 30.3571 8.88833 30.3571ZM8.99519 28.2011C7.61576 28.2011 6.89233 27.464 6.89233 26.1251V5.88854C6.89233 4.56282 7.61576 3.79882 9.0089 3.79882H23.0043C24.3969 3.79882 25.1072 4.54911 25.1072 5.88854V26.1251C25.1072 27.464 24.3969 28.2011 23.0175 28.2011H8.99519ZM10.9375 9.39711H21.0889C21.5575 9.39711 21.9192 9.02225 21.9192 8.55368C21.9192 8.09825 21.558 7.75025 21.0889 7.75025H10.9375C10.4415 7.75025 10.0935 8.09825 10.0935 8.55368C10.0935 9.02225 10.442 9.39711 10.9375 9.39711ZM10.9375 14.0714H21.0889C21.5575 14.0714 21.9192 13.6965 21.9192 13.2274C21.9192 12.7725 21.558 12.424 21.0889 12.424H10.9375C10.4415 12.424 10.0935 12.7725 10.0935 13.2274C10.0935 13.696 10.442 14.0714 10.9375 14.0714ZM10.9375 18.7457H15.7455C16.214 18.7457 16.5758 18.384 16.5758 17.9285C16.5758 17.46 16.214 17.0983 15.7455 17.0983H10.9369C10.4409 17.0983 10.0929 17.46 10.0929 17.9285C10.0929 18.384 10.4415 18.7457 10.9369 18.7457",
    fill: "#151D48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.afe225e8e77484c5a855537e7ef5c117.svg";
export { ForwardRef as ReactComponent };